import { render, staticRenderFns } from "./PromoModal.html?vue&type=template&id=f4752972&scoped=true&external"
import script from "./PromoModal.js?vue&type=script&lang=js&external"
export * from "./PromoModal.js?vue&type=script&lang=js&external"
import style0 from "./PromoModal.scss?vue&type=style&index=0&id=f4752972&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4752972",
  null
  
)

export default component.exports